<template>
  <div class="item">
    <div class="player">
      <video-player  class="vjs-custom-skin"
                     ref="videoPlayer"
                     :options="playerOptions"
                     :playsinline="true"
                     @ready="playerReadied">
      </video-player>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  props: ['list'],
  data () {
    return {
      // videojs options
      playerOptions: {
        height: '420',
        autoplay: false,
        muted: false,
        language: 'zh-CN',
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        preload: 'auto',
        sources: [{
          type: 'video/mp4',
          // mp4
          // src: 'http://vjs.zencdn.net/v/oceans.mp4'
          src: this.list.url
        }],
        // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg',
        notSupportedMessage: '此视频暂无法播放，请稍后再试'
      }
    }
  },
  mounted () {
    // console.log('this is current player instance object', this.player)
    setTimeout(() => {
      console.log('dynamic change options', this.player)
      this.player.muted(false)
    }, 5000)
    console.log(this.list.url)
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    // player is ready
    playerReadied (player) {
      // seek to 10s
      console.log('example player 1 readied', player)
      player.currentTime(0.5)
      // console.log('example 01: the player is readied', player)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/video/Index.vue